import { graphql, HeadFC } from "gatsby"

// ** Layout
import Layout from "../components/Layout"
import Box from "../components/Box"

// ** Custom Components
import { SEO } from "../components/SEO"

// ** 3rd Party Library
import ContentSections from "../components/PageBuilder/ContentSections"
import PageContext from "../contexts/PageContext"

import ContactUsSectionLocations from "../sections/contact/SectionContactLocation"
import TeamAgentsSectionStaffCards from "../sections/team-agents/TeamAgentsSectionStaffCards"
import CorporateTeamSectionStaffCards from "../sections/corporate-team/CorporateTeamSectionStaffCards"

const PageTemplate = (props: any) => {
  console.log(props)
  const {
    data: { page },
  } = props

  const renderCustomBlocks = () => {
    const currentPath = page?.slug?.current || "/"
    if (
      currentPath.includes("/contact-us") ||
      currentPath.includes("/contactez-nous")
    ) {
      return <ContactUsSectionLocations />
    } else if (
      currentPath.includes("/meet-our-corporate-team") ||
      currentPath.includes("/faites-connaissance-avec-notre-equipe-entreprise")
    ) {
      return <CorporateTeamSectionStaffCards />
    } else if (
      currentPath.includes("/meet-our-team-agents") ||
      currentPath.includes("/faites-connaissance-avec-notre-equipe")
    ) {
      return <TeamAgentsSectionStaffCards />
    }
  }

  const renderScript = () => {
    if (typeof window !== "undefined") {
      return <></>
    } else {
      return <></>
    }
  }

  return (
    <PageContext.Provider value={page}>
      <Layout pageContext={props.pageContext}>
        <Box
          as="main"
          className="flex flex-col min-h-screen gap-12 lg:gap-16 pt-14 md:pt-24"
        >
          {page && <ContentSections sections={page.sections} />}
          {renderCustomBlocks()}
        </Box>
      </Layout>
      {renderScript()}
    </PageContext.Provider>
  )
}

export const pageQuery = graphql`
  query Page($id: String!) {
    page: sanityPage(_id: { eq: $id }) {
      _key
      _id
      __typename
      seoTitle
      seoDescription
      i18n_lang
      slug {
        current
      }
      i18n_refs {
        i18n_lang
        slug {
          current
        }
      }
      i18n_base {
        i18n_lang
        slug {
          current
        }
      }
      sections {
        ...PageContent
      }
    }
  }
`

export const Head: HeadFC = ({ data }: any) => (
  <SEO
    title={data.page?.seoTitle || ""}
    description={data.page?.seoDescription || ""}
  />
)

export default PageTemplate
